export default {
    products: {},
    entities: {},
    newEntity: {},
    user: {},
    application: {},
    applications: {},
    accounts: {},
    authorisers: {},
    authRules: {},
    delegatedList: {},
    individual: {},
    entityInfo: {},
    impersonation: {},
    impersonationList:[],
    accountsEmpty: false,
    error: null,
    systemError: {},
    kyc: {saved: false},
    support: {},
    remediation: {},
    businessOnline: {bolRequest: {transactionDetails: {}, authorisation: {}}},
    tpfa: {application: {additionalProducts: {businessOnline: {}, cashManagement: {}}}}
  }
